import { Button } from "@/components/ui/button";
import { Sparkles, FileText, LogOut, Layers, ClipboardList, Menu, BookOpen, Upload } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import StudyStreak from "@/components/StudyStreak";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
import { useState } from "react";

const Navbar = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    setOpen(false);
    navigate('/');
  };

  const handleNavigate = (path: string) => {
    setOpen(false);
    navigate(path);
  };

  const NavItems = () => (
    <>
      <Button variant="ghost" size="sm" onClick={() => handleNavigate('/my-notes')} className="hover:bg-primary/20 hover:text-primary justify-start">
        <FileText className="w-4 h-4 mr-2" />
        My Notes
      </Button>
      <Button variant="ghost" size="sm" onClick={() => handleNavigate('/library')} className="hover:bg-primary/20 hover:text-primary justify-start">
        <BookOpen className="w-4 h-4 mr-2" />
        Library
      </Button>
      <Button variant="ghost" size="sm" onClick={() => handleNavigate('/share-notes')} className="hover:bg-primary/20 hover:text-primary justify-start">
        <Upload className="w-4 h-4 mr-2" />
        Share Notes
      </Button>
      <Button variant="ghost" size="sm" onClick={() => handleNavigate('/flashcards')} className="hover:bg-primary/20 hover:text-primary justify-start">
        <Layers className="w-4 h-4 mr-2" />
        Flashcards
      </Button>
      <Button variant="ghost" size="sm" onClick={() => handleNavigate('/quiz')} className="hover:bg-primary/20 hover:text-primary justify-start">
        <ClipboardList className="w-4 h-4 mr-2" />
        Quizzes
      </Button>
      <Button variant="outline" size="sm" onClick={handleSignOut} className="justify-start">
        <LogOut className="w-4 h-4 mr-2" />
        Sign out
      </Button>
    </>
  );

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
          <div className="w-9 h-9 rounded-lg gradient-primary flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="font-bold text-xl text-foreground">NoteGenius</span>
        </div>
        
        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-muted-foreground hover:text-foreground transition-colors">Features</a>
          <a href="#how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">How it Works</a>
          <a href="#pricing" className="text-muted-foreground hover:text-foreground transition-colors">Pricing</a>
        </div>
        
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <StudyStreak compact />
              {isMobile ? (
                <Sheet open={open} onOpenChange={setOpen}>
                  <SheetTrigger asChild>
                    <Button variant="ghost" size="icon">
                      <Menu className="w-5 h-5" />
                    </Button>
                  </SheetTrigger>
                  <SheetContent side="right" className="w-64 bg-background">
                    <div className="flex flex-col gap-2 mt-8">
                      <NavItems />
                    </div>
                  </SheetContent>
                </Sheet>
              ) : (
                <>
                  <Button variant="ghost" size="sm" onClick={() => navigate('/my-notes')} className="hover:bg-primary/20 hover:text-primary">
                    <FileText className="w-4 h-4 mr-2" />
                    My Notes
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => navigate('/library')} className="hover:bg-primary/20 hover:text-primary">
                    <BookOpen className="w-4 h-4 mr-2" />
                    Library
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => navigate('/share-notes')} className="hover:bg-primary/20 hover:text-primary">
                    <Upload className="w-4 h-4 mr-2" />
                    Share
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => navigate('/flashcards')} className="hover:bg-primary/20 hover:text-primary">
                    <Layers className="w-4 h-4 mr-2" />
                    Flashcards
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => navigate('/quiz')} className="hover:bg-primary/20 hover:text-primary">
                    <ClipboardList className="w-4 h-4 mr-2" />
                    Quizzes
                  </Button>
                  <Button variant="outline" size="sm" onClick={handleSignOut}>
                    <LogOut className="w-4 h-4 mr-2" />
                    Sign out
                  </Button>
                </>
              )}
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate('/auth')}>Log in</Button>
              <Button variant="hero" size="sm" onClick={() => navigate('/auth')}>Get Started Free</Button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
